import React from "react";

import { cn } from "../../../lib/utils";
import { StatusBadge } from "./fields";
import ListActions from "./ListActions";

interface Props {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  meta?: React.ReactNode;
  active?: boolean;
  leading?: React.ReactNode;
  onEdit: () => void;
  onDelete: () => void;
  deleteDisabled?: boolean;
  deleteTitle?: string;
}

/** Linha de lista em cartão: funciona bem no celular e segue o visual dos cards de reserva. */
export default function ListRow({
  title,
  subtitle,
  meta,
  active,
  leading,
  onEdit,
  onDelete,
  deleteDisabled,
  deleteTitle,
}: Props) {
  return (
    <div
      className={cn(
        "flex items-center gap-3 rounded-2xl border p-3 transition",
        active === false ? "border-white/5 bg-white/[0.02] opacity-70" : "border-white/10 bg-white/5"
      )}
    >
      {leading}
      <button type="button" className="min-w-0 flex-1 text-left" onClick={onEdit}>
        <p className="truncate text-sm font-semibold text-white">{title}</p>
        {subtitle && <p className="truncate text-xs text-white/60">{subtitle}</p>}
        {(meta || active !== undefined) && (
          <div className="mt-1.5 flex flex-wrap items-center gap-1.5">
            {active !== undefined && <StatusBadge active={active} />}
            {meta}
          </div>
        )}
      </button>
      <ListActions
        onEdit={onEdit}
        onDelete={onDelete}
        deleteDisabled={deleteDisabled}
        deleteTitle={deleteTitle}
      />
    </div>
  );
}
